export default "__VITE_PUBLIC_ASSET__13dd6f3d__"